/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_Log_Status_Skipped_DisabledInputs */

const he_account_delivery_log_status_skipped_disabled = /** @type {(inputs: Account_Delivery_Log_Status_Skipped_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דולג (מושבת)`)
};

const en_account_delivery_log_status_skipped_disabled = /** @type {(inputs: Account_Delivery_Log_Status_Skipped_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skipped (disabled)`)
};

/**
* | output |
* | --- |
* | "Skipped (disabled)" |
*
* @param {Account_Delivery_Log_Status_Skipped_DisabledInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_log_status_skipped_disabled = /** @type {((inputs?: Account_Delivery_Log_Status_Skipped_DisabledInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_Log_Status_Skipped_DisabledInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_log_status_skipped_disabled(inputs)
	return en_account_delivery_log_status_skipped_disabled(inputs)
});